import { forBiddenWords } from "views/AddNewServices/AddSingleService/constants";
export const validateUserName = (name: string, fiberProLabels: any) => {
    const expNumeric = /^[0-9]+$/;
    const specialCharsComplete = '!@#$%^&*()+=-[]\\\'.;,/{}|":<>?';
    const letters = /^[A-Za-z0-9]+$/;
    let index = -1,
        i = 0;
    if (name.charAt(0).match(expNumeric)) {
        return { error: fiberProLabels.numericUnError, isValid: false };
    }
    else if (name.length < 5 || name.length > 16) {
        return { error: fiberProLabels.userNameLengthError, isValid: false };
    } else if (forBiddenWords.some((forbiddenWord) => name.includes(forbiddenWord))) {
        return { error: fiberProLabels.choseAnotherUN, isValid: false };
    }  else if (!name.match(letters)) {
        return { error: fiberProLabels.onlyEnglishUnError, isValid: false };
    }
    while (i < name.length) {
        index = specialCharsComplete.indexOf(name.charAt(i));
        if (index !== -1) {
            return { error: fiberProLabels.specialCharUnError, isValid: false };
        }
        i++;
    }
    return { error: '', isValid: true };
};